module.exports = __webpack_public_path__ + "img/02.89c4cb1c.jpg";